import React from 'react'
import ReactDOM from 'react-dom/client'


import App from './App'

import './assets/fonts/Fira-Sans_300,500,400,600.css'

// Add global CSS for WCAG compliance
const globalStyles = `
  /* Screen reader only class */
  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  /* Focus visibility improvements - only for keyboard navigation */
  *:focus-visible {
    outline: 2px solid #1976d2 !important;
    outline-offset: 2px !important;
  }

  /* Remove focus outline for mouse users */
  *:focus:not(:focus-visible) {
    outline: none !important;
  }

  /* Remove default focus outlines */
  *:focus {
    outline: none !important;
  }

  /* Add focus outline only for keyboard navigation */
  .keyboard-navigation *:focus {
    outline: 2px solid #1976d2 !important;
    outline-offset: 2px !important;
  }

  /* Skip to main content link */
  .skip-link {
    position: absolute;
    top: -40px;
    left: 6px;
    background: #1976d2;
    color: white;
    padding: 8px;
    text-decoration: none;
    border-radius: 4px;
    z-index: 1000;
  }

  .skip-link:focus {
    top: 6px;
  }

  /* High contrast mode support */
  @media (prefers-contrast: high) {
    * {
      border-color: currentColor !important;
    }
    
    .MuiCard-root {
      border: 2px solid currentColor !important;
    }
  }

  /* Reduced motion support */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

// Inject global styles
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);

// Keyboard navigation detection
document.addEventListener('keydown', (e) => {
  // Check if the key is a navigation key
  if (['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Space', ' '].includes(e.key)) {
    document.body.classList.add('keyboard-navigation');
  }
});

document.addEventListener('mousedown', () => {
  document.body.classList.remove('keyboard-navigation');
});

document.addEventListener('touchstart', () => {
  document.body.classList.remove('keyboard-navigation');
});

ReactDOM
  .createRoot(document.getElementById("root"))
  .render(<App />)
